"use client";

import type { ReactNode } from "react";

import { cn } from "@homeinstead/ui";
import NavigationLogoButton from "~care/components/ui/NavigationMenu/PPC/NavigationLogoButton";

type NavigationBarLayoutProps = {
  containerClassName?: string;
  desktopCTA: ReactNode;
  mobileCTA: ReactNode;
};

export function NavigationBarLayout({
  containerClassName,
  desktopCTA,
  mobileCTA,
}: NavigationBarLayoutProps) {
  return (
    <nav
      className={cn(
        "bg-new-beginnings-base text-support-base shadow-navbar-ppc",
        containerClassName,
      )}
    >
      <div className="mx-auto flex h-20 max-w-screen-hd flex-row justify-between xl:px-[152px]">
        <div className="py-5 pl-5 sm:px-6 sm:py-4">
          <NavigationLogoButton />
        </div>

        <div className="hidden sm:flex sm:items-center sm:justify-end">
          {desktopCTA}
        </div>

        <div className="flex items-center justify-end sm:hidden">
          {mobileCTA}
        </div>
      </div>
    </nav>
  );
}
